const HOST = process.env.REACT_APP_HOST;
const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST;

export { HOST, IMAGE_HOST };
